<template>
	<div class="fullpage-nav" :class="active">
		<div class="row">
			<ul class="main-nav">
				<logo-button class="fullpage-nav-logo mobile" color="medium" @click="$emit('handle-logo-click')" />
				<li v-for="item in menu" :key="item.filename">
					<nuxt-link
						:exact="item.slug === 'index'"
						:to="'#' + item.header.trim()"
						@click="$emit('toggle-menu')"
					>
						{{ item.header }}
					</nuxt-link>
				</li>
			</ul>
		</div>

		<div class="nav-contact">
			<social-media :socials="socials" />
		</div>
	</div>
</template>

<script setup>
defineProps({
	menu: { type: Array, default: () => [] },
	socials: { type: Array, default: () => [] },
	active: { type: Boolean, default: false },
});

defineEmits(['toggle-menu', 'handle-logo-click']);
</script>

<style lang="scss" scoped>
.fullpage-nav {
	background: var(--dark-background-color);
	padding: 30px 50px;
	position: fixed;
	top: 0;
	left: 0;
	padding-top: 80px;
	z-index: 101;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: all 0.4s ease-in-out;
	visibility: hidden;

	.row {
		display: flex;
		flex-flow: column nowrap;
		justify-content: space-between;
		align-items: center;
		height: 100%;
	}
}

.fullpage-nav.active {
	opacity: 1;
	visibility: visible;
}

.main-nav {
	list-style: none;
	min-width: 25%;
	text-align: center;
	padding: 50px 0;
	height: 100%;
	display: flex;
	flex-flow: column wrap;
	justify-content: center;
	align-items: center;

	a {
		color: var(--nav-color-dark);
		font-family: var(--heading-font-family);
		font-size: 50px;
		line-height: 54px;
		font-weight: 400;
		text-transform: uppercase;
		letter-spacing: 2px;

		&:hover,
		&.active {
			color: #fff;
		}
	}
}

.nav-contact {
	padding: 20px 0;
	position: absolute;
	bottom: 20px;
	left: 0;
	right: 0;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
}

@media (max-height: 740px) {
	.fullpage-nav {
		overflow-y: scroll;
	}

	.main-nav {
		z-index: 2;
		position: relative;
	}
}

@media (max-width: 920px) {
	.fullpage-nav {
		padding: 10px 0 25px;
	}

	.main-nav {
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
		height: 100%;
	}
}

@media (max-width: 680px) {
	.fullpage-nav {
		flex-flow: column-reverse wrap;
		justify-content: flex-end;
	}
}
</style>
